import {merge} from 'lodash';
import AssessmentResult from '../../../values/AssessmentResult';
import Assessment from '../assessment';
import {SCHEMA_ID, TECHNICAL_SEO_POINTS} from '@axyseo/const/analysis';

/**
 * Represents the assessment that checks shop has schema.
 */
export default class SchemaAssessment extends Assessment {
  /**
   * Sets the identifier and the config.
   *
   * @param {object} config The configuration to use.
   *
   * @returns {void}
   */
  constructor(config = {}) {
    super();

    const defaultConfig = {
      id: SCHEMA_ID,
      priority: 'high',
      docUrl: 'https://docs.avada.io/seo-suite-help-center/seo-on-page-audit/checklist#schema',
      ctaType: 'contactUs',
      title: 'Schema',
      content: {
        good: 'Schema markup is applied effectively.',
        improve: '',
        bad: 'No schema markup applied. Add schema to optimize visibility for search engines.'
      }
    };

    this.identifier = SCHEMA_ID;
    this._config = merge(defaultConfig, config);
  }

  /**
   *
   * @param paper
   * @returns {{score: number, status: string}}
   */
  calculateResult(paper) {
    let status = 'bad';
    const url = paper.getSlug();

    if (url.includes('product')) {
      this._config = merge(this._config, {
        type: "product",
        title: 'Missing product structured data',
        content: {
          good: 'Product structured data added',
          bad: 'Add Product structured data for Google rich results eligibility.'
        }
      });
      if (paper.hasProductSchema()) {
        status = 'good';
      } else {
        status = 'bad';
      }
    }
    if (url.includes('collection')) {
      this._config = merge(this._config, {
        type: "collection",
        title: 'Missing collection structured data',
        content: {
          good: 'Collection structured data added',
          bad: 'Add Collection structured data for Google rich results eligibility.'
        }
      });
      if (paper.hasProductSchema()) {
        status = 'good';
      } else {
        status = 'bad';
      }
    }
    if (url.includes('blogs')) {
      this._config = merge(this._config, {
        type: "article",
        title: 'Missing article structured data',
        content: {
          good: 'Article structured data added',
          bad: 'Add Article structured data for Google rich results eligibility.'
        }
      });
      if (paper.hasArticleSchema()) {
        status = 'good';
      } else {
        status = 'bad';
      }
    }

    const score = this.getScore(TECHNICAL_SEO_POINTS, status);

    return {
      score,
      status
    };
  }

  /**
   *
   * @param paper
   * @param researcher
   * @param config
   * @returns {AssessmentResult}
   */
  getResult({paper, researcher}) {
    const calculatedResult = this.calculateResult(paper);
    const assessmentResult = new AssessmentResult({config: this._config});

    assessmentResult.setScore(calculatedResult.score);
    assessmentResult.setStatus(calculatedResult.status);

    return assessmentResult;
  }

  /**
   * Checks if the sentence beginnings assessment is applicable to the paper.
   *
   * @param {Object}      paper       The paper to check.
   * @param {Researcher}  researcher  The researcher object.
   * @returns {boolean} Returns true if the language is available and the paper is not empty.
   */
  isApplicable(paper, researcher) {
    return true
  }
}
